import { Icons } from '@dolcevia/ui/components/icons';
import { Bike } from '@dolcevia/ui/components/svg/bike';
import { Button } from '@dolcevia/ui/components/ui/button';
import {
  ToggleGroup,
  ToggleGroupItem,
} from '@dolcevia/ui/components/ui/toggle-group';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import Control from 'react-leaflet-custom-control';

export type DisplayedMarkers = {
  museums: boolean;
  villages: boolean;
  activities: boolean;
};

export interface ControlToggleProps {
  redirectUrl?: string;
  displayedMarkers: DisplayedMarkers;
  setDisplayedMarkers: React.Dispatch<React.SetStateAction<DisplayedMarkers>>;
}

export const ControlToggle = ({
  redirectUrl,
  displayedMarkers,
  setDisplayedMarkers,
}: ControlToggleProps) => {
  const t = useTranslations('Home.Map');
  return (
    <Control prepend position="topright">
      <div className="flex gap-4">
        {redirectUrl && (
          <Button asChild>
            <Link
              href={redirectUrl}
              target="_blank"
              className="button-marker"
              prefetch={false}
            >
              {t("Voir l'aventure!")}
              <Bike
                mainColor="#FFF"
                secondaryColor="#FFF"
                svgProps={{ className: 'h-[15px] w-auto pl-2' }}
              />
            </Link>
          </Button>
        )}
        <ToggleGroup variant="stroked" type="multiple">
          <ToggleGroupItem
            defaultChecked={displayedMarkers.villages}
            data-state={displayedMarkers.villages ? 'on' : 'off'}
            onClick={() =>
              setDisplayedMarkers((prev) => ({
                ...prev,
                villages: !prev.villages,
              }))
            }
            value="villages"
            aria-label="Toggle villages"
          >
            <Icons.villagesFrance className="h-4 w-4" />
          </ToggleGroupItem>
          <ToggleGroupItem
            defaultChecked={displayedMarkers.activities}
            data-state={displayedMarkers.activities ? 'on' : 'off'}
            onClick={() =>
              setDisplayedMarkers((prev) => ({
                ...prev,
                activities: !prev.activities,
              }))
            }
            value="activities"
            aria-label="Toggle activities"
          >
            🏹
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
    </Control>
  );
};
